import React, { useCallback, useContext, useEffect, useState, useRef } from 'react'
import { Col, Row, Card, Table, Spinner } from '@themesberg/react-bootstrap'
import { useCookies } from 'react-cookie'
import TableRow from '../component/TableRow'
import { calculatePage, formatNumber, getItemPerPage } from '../../../../helper/helper'
import Pagination from '../../../../components/Pagination'
import { Context } from '../TicketReturn'
import * as classicReturnApi from '../../../../controller/api/classicReturn'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faReceipt, faTicketAlt, faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import ImagePreview from "../../order/partials/image-preview/ImagePreview"

const _Table = () => {
  const { state, dispatch } = useContext(Context)
  const [cookies] = useCookies(['lottmekong'])

  const [data, setData] = useState({ list: [], total: 0, totalPage: 0 })
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [summary, setSummary] = useState(null)

  const [modalImageShow, setModalImageShow] = useState(false)
  const selectedImageRef = useRef("")
  const previewTitleRef = useRef("")

  const showImagePreview = (title, image) => {
    previewTitleRef.current = title;
    selectedImageRef.current = image;
    setModalImageShow(true);
  }

  const getAllFunc = useCallback(async () => {
    setLoading(true)
    dispatch({ type: 'SET_LOADING', payload: true })
    try {
      const query = {
        from: state.from,
        to: state.to,
        region: state.region || undefined,
        reason: state.reason || undefined,
        channelId: state.channelId || undefined
      }

      const response = await classicReturnApi.getList(cookies.lottmekong, query, page)

      if (response) {
        setData({
          list: response.data || [],
          total: response.total || 0,
          totalPage: calculatePage(response.total || 0)
        })
      }

      const summaryRes = await classicReturnApi.getSummary(cookies.lottmekong, query)
      if (summaryRes && summaryRes.success) {
        setSummary(summaryRes.data)
      }
    } finally {
      setLoading(false)
      dispatch({ type: 'SET_LOADING', payload: false })
    }
  }, [cookies.lottmekong, state.from, state.to, state.region, state.reason, state.channelId, page, dispatch])

  useEffect(() => {
    getAllFunc()
  }, [getAllFunc])

  return (
    <>
      {summary && (
        <Row className="mb-3">
          <Col md={4} sm={12} className="mb-3 mb-md-0">
             <Card border="light" className="shadow-sm h-100">
                <Card.Body className="d-flex align-items-center">
                   <div className="icon icon-shape icon-md icon-shape-primary rounded me-3">
                      <FontAwesomeIcon icon={faReceipt} />
                   </div>
                   <div>
                      <h6 className="fw-normal text-muted mb-1">Tổng số lần hoàn</h6>
                      <h4 className="fw-bold mb-0">{formatNumber(summary.totalCount)}</h4>
                   </div>
                </Card.Body>
             </Card>
          </Col>
          <Col md={4} sm={12} className="mb-3 mb-md-0">
             <Card border="light" className="shadow-sm h-100">
                <Card.Body className="d-flex align-items-center">
                   <div className="icon icon-shape icon-md icon-shape-danger rounded me-3">
                      <FontAwesomeIcon icon={faTicketAlt} />
                   </div>
                   <div>
                      <h6 className="fw-normal text-muted mb-1">Tổng số vé hoàn</h6>
                      <h4 className="fw-bold mb-0 text-danger">{formatNumber(summary.totalAmount)}</h4>
                   </div>
                </Card.Body>
             </Card>
          </Col>
          <Col md={4} sm={12}>
             <Card border="light" className="shadow-sm h-100">
                <Card.Body>
                   <h6 className="fw-normal text-muted mb-2"><FontAwesomeIcon icon={faExclamationCircle} className="me-1"/> Chi tiết lý do</h6>
                   <div className="d-flex flex-wrap gap-3">
                     {summary.byReason && summary.byReason.map((r, idx) => (
                        <div key={idx} className="d-flex align-items-center">
                           <span className="badge bg-light text-dark border me-2">{r.reasonText}</span>
                           <span className="fw-bold">{formatNumber(r.totalAmount)}</span>
                        </div>
                     ))}
                   </div>
                </Card.Body>
             </Card>
          </Col>
        </Row>
      )}

      {loading && (
        <div className="d-flex justify-content-center align-items-center py-5">
          <Spinner animation="border" role="status" variant="primary">
            <span className="visually-hidden">Đang tải...</span>
          </Spinner>
        </div>
      )}

      {!loading && (
        <Card border="light" className="shadow-sm border-0">
          <Card.Body className="p-0">
            <Table responsive className="align-items-center table-flush table-hover">
              <thead className="thead-light">
                <tr>
                  <th className="border-bottom text-center" scope="col">Ảnh</th>
                  <th className="border-bottom text-center" scope="col">STT</th>
                  <th className="border-bottom text-center" scope="col">Số vé</th>
                  <th className="border-bottom text-center" scope="col">Đài</th>
                  <th className="border-bottom text-center" scope="col">Ngày xổ</th>
                  <th className="border-bottom text-center" scope="col">SL Nhập</th>
                  <th className="border-bottom text-center" scope="col">SL Hoàn</th>
                  <th className="border-bottom text-center" scope="col">SL Còn</th>
                  <th className="border-bottom text-center" scope="col">Lý do</th>
                  <th className="border-bottom text-center" scope="col">Thời gian hoàn</th>
                </tr>
              </thead>
              <tbody>
                {data.list && data.list.map((item, index) => (
                  <TableRow
                    key={item.id}
                    rIndex={index + (page * getItemPerPage())}
                    {...item}
                    onPreviewImage={showImagePreview}
                  />
                ))}
                {(!data.list || data.list.length === 0) && (
                  <tr>
                    <td colSpan={10} className="text-center py-4 text-muted">Không có dữ liệu</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Card.Body>
          <Card.Footer className="border-0 py-3 bg-light">
            <Row className="align-items-center">
              <Col>
                <Pagination
                  totalPage={data.totalPage || 0}
                  currentPage={page || 0}
                  onPageChange={(i) => setPage(i)}
                />
              </Col>
            </Row>
          </Card.Footer>
        </Card>
      )}

      <ImagePreview
        show={modalImageShow}
        title={previewTitleRef.current}
        image={selectedImageRef.current}
        onHide={() => setModalImageShow(false)}
      />
    </>
  )
}

export default React.memo(_Table)
